// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3-M2T","info":"Note_info__14iyr","note":"Note_note__2II6w","actions":"Note_actions__1CE95"};